import useOnClickOutsideBase from 'use-onclickoutside';

export const DISABLE_ON_CLICK_OUTSIDE_CLASS = 'disable-useOnClickOutside';

export const hasIgnoredClass = (element) => element
    .classList
    .contains(DISABLE_ON_CLICK_OUTSIDE_CLASS);

export const isInIgnoredElement = (element) => {
    let result = false;
    let elementToCheck = element;
    do {
        if (hasIgnoredClass(elementToCheck)) {
            result = true;
            break;
        }
    } while ((elementToCheck = elementToCheck.parentElement));
    return result;
};

export const handlerCreator = (handler) => (event) => {
    if (!isInIgnoredElement(event.target)) {
        handler();
    }
};

function useOnClickOutside(ref, handler) {
    useOnClickOutsideBase(ref, handlerCreator(handler));
}

export default useOnClickOutside;
